var map = {
	"./all-words.ts": 741,
	"./country-names.ts": 413,
	"./football-terms.ts": 795,
	"./living-creatures.ts": 342,
	"./long-words.ts": 534,
	"./medium-words.ts": 119,
	"./short-words.ts": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 429;